"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Evidence = void 0;
const react_1 = __importDefault(require("react"));
const react_virtualized_auto_sizer_1 = __importDefault(require("react-virtualized-auto-sizer"));
const table_1 = require("../table/table");
const evidence_hook_1 = require("./evidence-hook");
const evidence_styles_1 = require("./evidence-styles");
const screen_mode_hook_1 = require("./hook/screen-mode-hook");
const detail_1 = require("../detail/detail");
const toolbar_hook_1 = require("./hook/toolbar-hook");
const evidence_context_1 = require("./evidence-context");
const split_screen_1 = require("../../components/split-screen/split-screen");
function Evidence(props) {
    const { tableProps, detailProps, switcherProps } = props;
    const { columns, FieldsComponent, tableSource, crudSource, splitScreenRef, tableRef, detailRef, handleActiveRowChange, handleDetailPersisted, } = evidence_hook_1.useEvidence(props);
    screen_mode_hook_1.useScreenMode({
        splitScreenRef,
        hideMenuTools: switcherProps === null || switcherProps === void 0 ? void 0 : switcherProps.hideMenuTools,
    });
    const { BeforeToolbar } = toolbar_hook_1.useEvidenceTableToolbar({ tableRef });
    const classes = evidence_styles_1.useStyles();
    return (react_1.default.createElement(evidence_context_1.EvidenceContext.Provider, { value: {
            apiUrl: props.apiProps.url,
            tableSource,
            crudSource,
            tableRef,
            detailRef,
        } },
        react_1.default.createElement("div", { className: classes.evidence },
            react_1.default.createElement(react_virtualized_auto_sizer_1.default, { disableWidth: true }, ({ height }) => (react_1.default.createElement("div", { style: { height, display: 'flex' } },
                react_1.default.createElement(split_screen_1.SplitScreen, { ref: splitScreenRef, rightLabel: switcherProps === null || switcherProps === void 0 ? void 0 : switcherProps.rightLabel, leftLabel: switcherProps === null || switcherProps === void 0 ? void 0 : switcherProps.leftLabel },
                    react_1.default.createElement(table_1.Table, Object.assign({ tableId: props.identifier + '_TABLE', version: props.version, ref: tableRef }, tableProps, { columns: columns, source: tableSource, height: height, onActiveChange: handleActiveRowChange })),
                    react_1.default.createElement(detail_1.Detail, Object.assign({ toolbarProps: { before: BeforeToolbar }, ref: detailRef }, detailProps, { FieldsComponent: FieldsComponent, source: crudSource, onPersisted: handleDetailPersisted })))))))));
}
exports.Evidence = Evidence;
//# sourceMappingURL=evidence.js.map